var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-label-container"},[_c('label',{staticClass:"form-label",attrs:{"for":_vm.id}},[_vm._t("default")],2),_vm._v(" "),(_vm.hasHelp)?_vm._t("help"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }